export const DOC_TYPES = {
    SOURCES: 'sources',
    MIGRATION: 'migration',
};

export const DOCUMENTATION = {
    [DOC_TYPES.SOURCES]: {
        links: {
            IndividualSources: 'https://docs.rivermeadow.com/add-individual-sources',
            MultipleSources: 'https://docs.rivermeadow.com/add-multiple-sources',
            VMBasedSources: 'https://docs.rivermeadow.com/adding-vm-based-sources',
            InspectSources: 'https://docs.rivermeadow.com/inspect-sources',
        },
        labels: {
            IndividualSources: 'Add Individual Sources',
            MultipleSources: 'Add Multiple Sources',
            VMBasedSources: 'Adding VM-Based Sources',
            InspectSources: 'Inspecting Sources',
        },
        buttonText: 'How To Add Sources',
    },

    [DOC_TYPES.MIGRATION]: {
        links: {
            Azure: 'http://docs.rivermeadow.com/azure-migration',
            AzureLocal: 'https://docs.rivermeadow.com/microsoft-azure-local-migration',
            GCP: 'http://docs.rivermeadow.com/gcp-migration',
            AWS: 'https://docs.rivermeadow.com/aws-migrations',
            vSphere: 'http://docs.rivermeadow.com/vsphere-standalone-migration',
            OpenShift: 'https://docs.rivermeadow.com/openshift-migration',
            OpenStack: 'https://docs.rivermeadow.com/openstack-migration',
            HPE: 'https://docs.rivermeadow.com/hpe-vme-osb-migration',
            NC2: 'https://docs.rivermeadow.com/nutanix-osb-migration',
            HyperV: 'https://docs.rivermeadow.com/microsoft-hyper-v-migration',
        },
        labels: {
            Azure: 'Azure',
            AzureLocal: 'Azure Local',
            GCP: 'Google Cloud',
            AWS: 'AWS',
            vSphere: 'vSphere',
            OpenShift: 'OpenShift',
            OpenStack: 'OpenStack',
            HPE: 'HPE',
            NC2: 'Nutanix',
            HyperV: 'Hyper-V',
        },
        buttonText: 'Instructions By Target Cloud Type',
    },
};
